import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TooltipModule } from "~shared/modules/tooltip/tooltip.module";
import { VatDisclaimerPLPsComponent } from "~shared/components/vat-disclaimer-plps/vat-disclaimer-plps.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    QaLocatorsModule,
    FlexModule,
    TooltipModule
  ],
  declarations: [
    VatDisclaimerPLPsComponent
  ],
  exports: [
    VatDisclaimerPLPsComponent
  ]
})

export class VatDisclaimerPLPs {}
